import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-invoicelist',
  templateUrl: './invoicelist.component.html',
  styleUrls: ['./invoicelist.component.css']
})
export class InvoicelistComponent implements OnInit {
  data: any;
  InvoiceDocs: any;
  readonly rootUrl = environment.baseUrl;
  
  constructor(private invoiceservices: InvoiceService, private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getAllInvoiceList();
  }
  invoiceSearch(keyword) {
    this.invoiceservices.invoiceListSearch(keyword).subscribe(
      (data) => {
        // this.InvoiceDocs = data;
        //console.log(data);
      }
    )

  }

  getAllInvoiceList() {
    this.invoiceservices.getAllInvoiceList().subscribe(
      (data: any) => {
        this.InvoiceDocs = data;
        console.log(this.data);
      }
    )
  }

  // getSelectedInvoiceLines(invoiceid) {
  //   //alert(invoiceid);
  //   this.invoiceservices.getSelectedInvoiceLines(invoiceid).subscribe(
  //     (data: any) => {
  //       this.data = data;
  //       console.log(this.data);
  //     }
  //   )
  // }

  getSelectedInvoiceLines(invoiceid)
  {
    //alert(invoiceid);
    // this.invoiceservice.getSelectedInvoiceLines(invoiceid).subscribe(
    //   (data : any) => {
    //     this.data = data;
    //     console.log(this.data);
    //   }
    // )
    //invoiceid = 1;
    this.router.navigate(['/viewinvoicedetail/' + invoiceid + '']);
  }

  invoicesearch(keyword)
  {
    this.invoiceservices.searchInvoice(keyword).subscribe(
      (data) => {
        this.InvoiceDocs = data;
        console.log(data);
      }
    );
  }

}
